import { render, staticRenderFns } from "./SignAdapter.vue?vue&type=template&id=72a68b34&"
import script from "./SignAdapter.vue?vue&type=script&lang=ts&"
export * from "./SignAdapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports